<template>
    <v-sheet class="defaultCard" color="bgtopology">
        <span  class="titlePages">{{  t('analyticsPage.titlerx') }}</span>
        <v-row  class="ma-0" v-if="showPredict" >
            <v-col  
            class="my-3" 
            cols="12" sm="4" md="3" lg="2" xl="2"
            v-for="(item,i) in principalData" 
            :key="i"           
            >
                <CardTopology
                :status="item.status"
                :ip="item.ip"
                :title="item.name"
                :description="item.tipo" 
                @click="pressItem(item.ip,item.name)"           
                />
            </v-col>

            <!-- DIALOG -->
            <v-dialog
                v-model="dialog"
                width="85%"
                >
                <v-card class="card_dialog" color="background">
                    <v-row class="ma-0" justify="space-between" style="align-items: self-end !important;" >
                        <v-col cols="10">
                            <h4 v-if="xs"> {{ t('title.graphTitle')}} {{ titleDialog }}</h4>
                            <h2 v-else> {{ t('title.graphTitle')}} {{ titleDialog }}</h2>
                        </v-col>
                        <v-col cols="1">
                            <v-btn icon="mdi-close" variant="plain" @click="dialog = false"></v-btn>
                        </v-col>
                        <v-col v-if="valorTwo.length !== 0" cols="12" :style="xs ? 'text-align:start' :'text-align:end'" class="pr-16">
                            <span :class="xs ? 'datePredict' : ''">
                                {{ t('analyticsPage.titleDial1') }} [ {{  titleDate }} ] - {{ t('analyticsPage.titleDial2') }} {{  titleValue }}
                            </span>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-sheet class="defaultCard text-center"  color="bgtopology">
                        <CompareCharts
                        v-if="valorOne.length > 0  && valorTwo.length > 0"
                        name-primary="Real" 
                        :color-first="COLOR.compare13"
                        :color-second="COLOR.compare14"
                        :name-secundary="t('labels.predict')" 
                        :title="t('analyticsPage.predvsreal1')"
                        :subtitle="t('analyticsPage.predvsreal2')"
                        :first-array="valorOne" 
                        :second-array="valorTwo" 
                        :typeChart="STRING_GENERAL.predict" />
                        <Prog_circular v-else/>
                    </v-sheet>
                    <v-sheet class="defaultCard"  color="bgtopology">
                        <EasyDataTable
                        table-class-name="customize-table"
                        :headers="finalHeardes"
                        :items="items"
                        show-index
                        hide-footer
                        >
                        </EasyDataTable>
                    </v-sheet>    
                </v-card>
            </v-dialog>
        </v-row>
        <v-row v-else  class="ma-0 px-4 py-3">
            <h3> {{t('noInformation')}} </h3>
        </v-row>
    </v-sheet>  
</template>
<script setup lang="ts">
import { computed, onMounted, ref, Ref, ComputedRef } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import CardTopology from '@/components/SmartLink/topology/CardTopology.vue';
import CompareCharts from '@/components/SmartLink/charts/CompareCharts.vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL } from '@/constants/labels';
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 ********** INTERFACES **********
 *******************************/
import { PREDICT_GRAPH } from '@/interfaces/SmartLink/IA';
import { HEADER } from '@/interfaces/SmartLink/Tables'

/********************************
 *********** SERVICES ***********
 *******************************/
import { getAllPredictionRXTXData, getPredictionRXTXByIP } from '@/services/Smartlink/Predict';

/**
 * HEADER de la tabla
 */
const finalHeardes:ComputedRef<HEADER[]> = computed(() => [
    { text:  t('labels.date'),      value: "fecha",     sortable: false},
    { text:  t('labels.ip'),        value: "ip",        sortable: false},
    { text:  t('labels.cause'),     value: "causa",     sortable: false},
    { text:  t('labels.value'),     value: "detalle",   sortable: false},
])

/**
 * Mostrar el Dialogo
 */
const dialog = ref(false);

/**
 * Si es false, el apartado de error, en vez de mostrar información o un espacio vacío. 
 * Generalmente es cuando desde la API no trae valores.
 * Si es true, muestra todal a información obtenida de la API
 */
const showPredict = ref(false);

/**
 * Son los parámetros que se envían a la API
 */
const params = ref({link : ''});

/**
 * Nombre del equipo seleccionado para mostrar su dialog
 */
 const titleDialog = ref('');

/**
 * Cuando le das click a algún item, captura su ip y su nombre
 * lo manda a la función "getPredict" mandando su parametros
 * all => para la tabla
 * pred/real => para el gráfico
 * muestra el dialog de los gráficos
 */
function pressItem(ip:string, name:string) {
    dialog.value        = true;
    titleDialog.value   = name;
    params.value.link   = ip;
    getPredict(STRING_GENERAL.predictall);
    getPredict(STRING_GENERAL.predictreal);
    getPredict(STRING_GENERAL.predictpred);
}


/**
 * Valor principal de los predicts
 */
const principalData = ref();

/**
 * Captura todos los items tienen predicciones
 * traidos de la API: "getAllPredictRXLVLData"
 */
async function getAllPredRXData() {

    const allData = await getAllPredictionRXTXData()

    showPredict.value = allData.showGraphs;

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        principalData.value = allData.data
    }
     
}


/**
 * Valor Real del gráfico
 */
 const valorOne:Ref<number[][]>      = ref([]);

/**
 * Valor Predict del Gráfico
 */
const valorTwo:Ref<number[][]>      = ref([]);

/**
 * Valor de la tabla
 */
const items:Ref<PREDICT_GRAPH[]>    = ref([]);

/**
 * Fecha del predict
 */
 const titleDate                     = ref('');

/**
 * Valor del predict
 */
const titleValue                    = ref('');

/**
 * Hace el pedido a la API según el tipo
 * @param type Tipo de Predicción de la API 
 */
async function getPredict(type:string) {

    const allData = await getPredictionRXTXByIP(type, params.value);

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        if(type === STRING_GENERAL.predictall)     items.value    = allData.data;
        if(type === STRING_GENERAL.predictreal)    {
            valorOne.value = allData.data;
        }

        if(type === STRING_GENERAL.predictpred){
            valorTwo.value = allData.data;

            const fecha         =  new Date(allData.data.slice(-1)[0][0]);
            titleDate.value     = fecha.toLocaleString("es-PE");
            titleValue.value    = (allData.data.slice(-1)[0][1]).toString();
        }    
    } 
}

onMounted(()=>{
    getAllPredRXData();
})

</script>

<style>
.datePredict{
    font-size: 13px;
}
</style>